import React, { useState } from 'react';
import styled from '@emotion/styled';
import { BsGripVertical } from 'react-icons/bs';
import { FaCheck } from 'react-icons/fa';
import { IoMdClose } from 'react-icons/io';
import { toast } from 'react-toastify';

const OrderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
`;

const OrderControls = styled.div`
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${(props) => (props.isEditing ? '#e6e6e6d6' : 'transparent')};
    box-shadow: ${(props) => (props.isEditing ? 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' : 'none')};
    padding: ${(props) => (props.isEditing ? '10px' : '0')};
`;

const ButtonGroup = styled.div`
    display: flex;
    gap: 6px;
    margin-bottom: 4px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`;

const OrderButton = styled.button`
    font-size: 16px;
    padding: 2px 6px;
    min-width: 28px;
`;

const OrderInput = styled.input`
    width: 60px;
    font-size: 14px;
    text-align: center;
    padding: 4px;
    border: 2px solid #50aeb0;
    border-radius: 6px;
`;

const OrderLabel = styled.div`
    cursor: text;
    font-weight: bold;
    font-size: 14px;
`;

const FormElementOrder = ({ index, editingOrderIndex, formElements, setEditingOrderIndex, handleInputReorder }) => {
    const isEditing = editingOrderIndex === index;
    const [tempOrderValue, setTempOrderValue] = useState('');

    return (
        <OrderContainer>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                <div>
                    <BsGripVertical size={24} />
                </div>
            </div>

            <div>
                <OrderControls isEditing={isEditing}>
                    {isEditing ? (
                        <>
                            <ButtonGroup>
                                <OrderButton
                                    className="btn btn-primary btn-sm"
                                    onClick={() => {
                                        const newIndex = Number(tempOrderValue) - 1;
                                        if (newIndex === index) return;
                                        if (isNaN(newIndex) || newIndex < 0 || newIndex >= formElements.length) {
                                            return toast.warning('Please select a valid ordering number');
                                        }
                                        handleInputReorder(index, newIndex);
                                    }}
                                >
                                    <FaCheck size={16} />
                                </OrderButton>
                                <OrderButton
                                    className="btn btn-danger btn-sm"
                                    onClick={() => setEditingOrderIndex(null)}
                                >
                                    <IoMdClose size={16} />
                                </OrderButton>
                            </ButtonGroup>
                            <OrderInput
                                type="number"
                                min={1}
                                max={formElements.length}
                                value={tempOrderValue}
                                onChange={(e) => setTempOrderValue(e.target.value)}
                            />
                        </>
                    ) : (
                        <OrderLabel
                            onClick={() => {
                                setEditingOrderIndex(index);
                                setTempOrderValue(index + 1);
                            }}
                        >
                            #{index + 1}
                        </OrderLabel>
                    )}
                </OrderControls>
            </div>
        </OrderContainer>
    );
};

export default FormElementOrder;
